<template>
 <div>
   <div v-if="detail[0].status_code === 1">
    <div class="progress-wrap progress-4steps car-inspection-flow mb16">
      <ul class="progressbar clearfix">
        <li class="active"><span>お申し込み</span></li>
        <li class=""><span>日程確定</span></li>
        <li class=""><span>お預かり中</span></li>
        <li class=""><span>車検完了</span></li>
      </ul>
    </div>
  </div>
  <div v-if="detail[0].status_code === 2">
    <div class="progress-wrap progress-4steps car-inspection-flow mb16">
      <ul class="progressbar clearfix">
        <li class="passed"><span>お申し込み</span></li>
        <li class="active"><span>日程確定</span></li>
        <li class=""><span>お預かり中</span></li>
        <li class=""><span>車検完了</span></li>
      </ul>
    </div>
  </div>
  <div v-if="detail[0].status_code === 3">
    <div class="progress-wrap progress-4steps car-inspection-flow mb16">
      <ul class="progressbar clearfix">
        <li class="passed"><span>お申し込み</span></li>
        <li class="passed"><span>日程確定</span></li>
        <li class="active"><span>お預かり中</span></li>
        <li class=""><span>車検完了</span></li>
      </ul>
    </div>
  </div>
  <div v-if="detail[0].status_code === 4">
    <div class="progress-wrap progress-4steps car-inspection-flow mb16">
      <ul class="progressbar clearfix">
        <li class="passed"><span>お申し込み</span></li>
        <li class="passed"><span>日程確定</span></li>
        <li class="passed"><span>お預かり中</span></li>
        <li class="active"><span>車検完了</span></li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: [
    'detail'
  ]
}
</script>
